import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { BORDER_RADIUS, ERROR_COLOR, GL_BRIGHT_COLOR } from "../constants";

export interface InputContainerProps {
  focused: boolean;
  error: boolean;
  cursor?: string;
  borderColor: string;
  backgroundColor: string;
}

export const InputContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "focused" && prop !== "error" && prop !== "borderColor" && prop !== "cursor",
})<InputContainerProps>(({ theme, focused, error, cursor, borderColor, backgroundColor }) => ({
  position: "relative", // Add position relative for floating label
  border: `1px solid ${borderColor}`,
  borderRadius: BORDER_RADIUS,
  padding: "0px 20px",
  display: "flex",
  alignItems: "center",
  minHeight: "42px",
  transition: theme.transitions.create(["border-color", "box-shadow"]),
  ...((focused || error) && {
    boxShadow: `0 0 0 1px ${error ? ERROR_COLOR : GL_BRIGHT_COLOR}`,
  }),
  cursor,
  backgroundColor,
}));
